import { useCallback } from 'react';
import { ChainID } from '@ankr.com/chains-list';

import { setRedirectURL } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useCurrentPath } from 'modules/common/hooks/useCurrentPath';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';
import { waitForLocalStorageSync } from 'modules/common/utils/waitForLocalStorageSync';
import { chainsRoutesConfig } from 'domains/chains/routes';

export const useSignInHandler = (chainID?: ChainID) => {
  const { handleSignIn } = useSSOAuth({ hasAPIKeysNotification: true });

  const dispatch = useAppDispatch();

  const currentPath = useCurrentPath();

  const signIn = useCallback(async () => {
    const redirectUrl = chainID
      ? chainsRoutesConfig.chainDetails.generatePath(chainID)
      : currentPath;

    dispatch(setRedirectURL(redirectUrl));

    await waitForLocalStorageSync();

    handleSignIn();
  }, [chainID, currentPath, dispatch, handleSignIn]);

  return { signIn };
};
